import React from "react";
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  TextField,
  InputAdornment,
} from "@mui/material";
import { AccountBalance as AccountBalanceIcon } from "@mui/icons-material";
import { orange } from "@mui/material/colors";

const FeeLimitsSettings = ({ settings, onSettingChange }) => {
  const feeLimitsSettings = settings.feeLimits;

  const handleInputChange = (key, value) => {
    const processedValue = parseInt(value) || 0;
    console.log(`Updating fee limits ${key} to:`, processedValue);
    onSettingChange("feeLimits", key, processedValue);
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card elevation={3}>
          <CardHeader
            avatar={<AccountBalanceIcon sx={{ color: orange[500] }} />}
            title="Fee Limits & Transaction Caps"
            subheader="Configure maximum fees and transaction limits"
            sx={{ bgcolor: orange[50] }}
          />
          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Max Room Join Fee"
                  type="number"
                  value={feeLimitsSettings.max_room_join_fee || ""}
                  onChange={(e) =>
                    handleInputChange("max_room_join_fee", e.target.value)
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">🪙</InputAdornment>
                    ),
                  }}
                  helperText="Maximum coins that can be charged to join a room"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Max Room Watch Fee"
                  type="number"
                  value={feeLimitsSettings.max_room_watch_fee || ""}
                  onChange={(e) =>
                    handleInputChange("max_room_watch_fee", e.target.value)
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">🪙</InputAdornment>
                    ),
                  }}
                  helperText="Maximum coins that can be charged to watch a room"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Max Tip Amount"
                  type="number"
                  value={feeLimitsSettings.max_tip_amount || ""}
                  onChange={(e) =>
                    handleInputChange("max_tip_amount", e.target.value)
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">🪙</InputAdornment>
                    ),
                  }}
                  helperText="Maximum coins for a single tip"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Min Tip Amount"
                  type="number"
                  value={feeLimitsSettings.min_tip_amount || ""}
                  onChange={(e) =>
                    handleInputChange("min_tip_amount", e.target.value)
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">🪙</InputAdornment>
                    ),
                  }}
                  helperText="Minimum coins for a single tip"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Daily Transaction Limit"
                  type="number"
                  value={feeLimitsSettings.daily_transaction_limit || ""}
                  onChange={(e) =>
                    handleInputChange("daily_transaction_limit", e.target.value)
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">🪙</InputAdornment>
                    ),
                  }}
                  helperText="Maximum coins a user can transact per day"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Monthly Transaction Limit"
                  type="number"
                  value={feeLimitsSettings.monthly_transaction_limit || ""}
                  onChange={(e) =>
                    handleInputChange(
                      "monthly_transaction_limit",
                      e.target.value
                    )
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">🪙</InputAdornment>
                    ),
                  }}
                  helperText="Maximum coins a user can transact per month"
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default FeeLimitsSettings;
